import React, { useEffect, useState } from "react";
import { Grid, Heading, Text } from "@chakra-ui/react";
import EventCard from "../components/EventCard";
import Menu from "../components/Menu";
import { setTitle } from "../helpers/title";
import { Link, useNavigate } from "react-router-dom";
import { FaPlusCircle } from "react-icons/fa";
import { baseService } from "../helpers/baseService";
import { config } from "../helpers/config";
import LoadingPage from "../components/LoadingPage";

export default function EventList() {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loadingPage, setLoadingPage] = useState(false);

  useEffect(() => {
    setTitle("Event | Home");
  }, []);

  useEffect(() => {
    setLoadingPage(true);
    baseService.get(
      config.services.global.getEvent,
      (res) => {
        setEvents(res.data);
        setLoadingPage(false);
      },
      (err) => console.log(err)
    );
  }, []);

  return (
    <div>
      <div className="container" />
      <div className="content">
        {loadingPage && <LoadingPage />}
        <Heading size="lg" mb={6}>
          Events List
        </Heading>
        <Grid
          placeItems="center"
          border="2px dashed #3182ce"
          borderRadius={6}
          padding={3}
          margin="16px 0"
          backgroundColor="gray.50"
          cursor="pointer"
          gap={1}
          onClick={() => navigate("/event/create")}
        >
          <FaPlusCircle fontSize={18} color="gray" />
          <Text>Buat Event</Text>
        </Grid>
        {events.map((event) => {
          return (
            <Link to={`/event/details/${event._id}`} key={event._id}>
              <EventCard data={event} />
            </Link>
          );
        })}
      </div>
      <Menu />
    </div>
  );
}
